import ReactGA from 'react-ga4';

let isInitialized = false;

/**
 * Initialize Google Analytics
 * Only runs in production when REACT_APP_GA_MEASUREMENT_ID is set
 */
export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

  if (measurementId && !isInitialized) {
    ReactGA.initialize(measurementId);
    isInitialized = true;
    console.log('Google Analytics initialized with ID:', measurementId);
  } else if (!measurementId) {
    console.log('Google Analytics not initialized - no measurement ID provided');
  }
};

/**
 * Track page view
 * @param {string} path - The page path to track
 */
export const trackPageView = (path) => {
  if (isInitialized) {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};

/**
 * Track custom event
 * @param {string} category - Event category
 * @param {string} action - Event action
 * @param {string} label - Event label (optional)
 * @param {number} value - Event value (optional)
 */
export const trackEvent = (category, action, label, value) => {
  if (isInitialized) {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
  }
};
